import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SecureLinkAuthenticationComponent } from '../Components/secure-link-authentication/secure-link-authentication.component';
import { DashBoardService } from '../User/Pages/dash-board/dash-board.service';
import {  switchMap } from 'rxjs/operators';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class SecureLinkAuthenticationGuard implements CanActivate {
  constructor(
    private dialog: NgbModal,
    public dashBoardService: DashBoardService,
    public notify: NotificationService,
    public router: Router
  ) {}
  info;
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    this.info = null;
    return this.dashBoardService.GetFileLinkStatus(next.params.id).pipe(
      switchMap(({ data }) => {
        if (data.isExists) {
          const dialogRef = this.dialog.open(
            SecureLinkAuthenticationComponent,
            {
              centered: true,
              backdrop: 'static',
              keyboard: false,
            }
          );
          dialogRef.componentInstance.id = next.params.id;
          return dialogRef.closed.toPromise().then((resp) => {
            this.info = resp;
            return true;
          });
        }
        this.notify.showWarning(data.message);
        this.router.navigateByUrl('/');
        return of(false);
      })
    );
  }
}
